import { inject, InjectionKey, provide, ref, Ref } from 'vue'

export const TransformerIdInjectionKey: InjectionKey<Ref<string>> = Symbol('TransformerIdInjectionKey')

export const useTransformerId = () => inject(TransformerIdInjectionKey) ?? ref('')

export const provideTransformerId = (transformerId: Ref<string>) => provide(TransformerIdInjectionKey, transformerId)
